const transformPlacementToVertices = (placement) => {
  return placement.map((vertex) => {
    const transformedVertex = {
      coordinate: {
        x: vertex.x / 100,
        y: vertex.y / 100
      }
    };
    if (vertex.curve !== null) {
      transformedVertex.curve = {
        x: vertex.curve.x / 100,
        y: vertex.curve.y / 100
      };
    }
    return transformedVertex;
  });
};

export { transformPlacementToVertices };
//# sourceMappingURL=transformPlacementToVertices.js.map
